var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFbHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8941 11.3023L11.464 7.68118H7.95332V5.32748C7.95332 4.33734 8.44345 3.36984 10.0107 3.36984H11.6293V0.28626C10.6867 0.135952 9.7343 0.0546359 8.77971 0.0429688C5.89019 0.0429687 4.00375 1.77996 4.00375 4.92011V7.68118H0.800781V11.3023H4.00375V20.0607H7.95332V11.3023H10.8941Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbHover);
export default __webpack_public_path__ + "static/media/fb-hover.985f48f977aac93e026342bdc40ad3ab.svg";
export { ForwardRef as ReactComponent };